import classnames from "classnames";
import * as _ from "lodash";
import * as React from "react";
import * as S from "@styled";
import Select from "shared/components/select/Select";

import { connect } from "react-redux";
import { DispatchType, Utilities } from "../../shared/utilities";
import { updateParameter } from "../actions/UpdateParameter";
import { IValueLabel } from "../model/ITriggerData";
import { State } from "../model/State";
import { Option } from "shared/model/Option";
import { MenuPlacement } from "react-select";

export const DropdownInput: React.FC<DropdownInputProps> = (props) => {

    function handleChange(e: Option) {
        if (props.onChange) {
            props.onChange(e.value);
        }
        if (props.onUpdated) {
            props.onUpdated(e.value, props.identifier);
        }
    }

    const value = _.get(props.existingParameters, props.identifier as string, props.defaultValue);

    const options = props.dropdownModel && props.dropdownModel.map(({ label, value }) => ({
        label,
        value
    }))

    return (
        <S.FormGroup className={classnames(props.extraClasses as string)}>
            {props.label != null ? <S.Label>{props.label}</S.Label> : null}
            <Select
                classNamePrefix="react-select"
                value={Utilities.valueFromId(options, value)}
                options={options}
                placeholder={FRENDS.Localizations.Select}
                isDisabled={props.disabled}
                onChange={handleChange}
                menuPlacement={props.menuPlacement}
            />
        </S.FormGroup>
    );
};

interface DropdownInputProps {
    elementId?: string;
    existingParameters?: any;
    identifier?: string;
    label?: string | null;
    disabled?: boolean;
    defaultValue?: any;
    notSelectedLabel?: string;
    dropdownModel?: IValueLabel[];
    extraClasses?: string;
    menuPlacement?: MenuPlacement;
    onChange?: (value: any) => void;
    onUpdated?: (newValue: any, key: string | undefined) => void;
}

const mapStateToProps = (state: State, ownProps: DropdownInputProps): DropdownInputProps => {
    const existing = ownProps.existingParameters || state.elements[ownProps.elementId as string].parameters;
    return {
        existingParameters: existing,
        disabled: state.uiState.disableEdit || ownProps.disabled
    };
};

const mapDispatchToProps = (dispatch: DispatchType<State>, ownProps: DropdownInputProps): DropdownInputProps => {
    return {
        onChange: (value) => dispatch(updateParameter(ownProps.elementId, ownProps.identifier, value))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DropdownInput);
